/**
 * 工作任务管理 API
 */
import api from '../api';

export function listDailyReports(params) {
  return api.get('/work-task/daily-reports', { params });
}

export function getDailyReport(id) {
  return api.get(`/work-task/daily-reports/${id}`);
}

export function listAuditRules() {
  return api.get('/work-task/audit-rules');
}

export function updateAuditRule(id, body) {
  return api.put(`/work-task/audit-rules/${id}`, body);
}

export function toggleAuditRule(id) {
  return api.post(`/work-task/audit-rules/${id}/toggle`);
}

export function startTask(id) {
  return api.post(`/work-task/tasks/${id}/start`);
}

export function submitTaskVerify(id) {
  return api.post(`/work-task/tasks/${id}/submit-verify`);
}

export function cleanupStressTest(params) {
  return api.post('/work-task/verifications/stress-test/cleanup', null, { params });
}

export function ingestDailyReport(body) {
  return api.post('/work-task/daily-reports/ingest', body);
}

export function reauditDailyReport(rawId) {
  return api.post(`/work-task/daily-reports/${rawId}/reaudit`);
}

export function manualReviewDailyReport(rawId, approved, comment = '') {
  return api.post(`/work-task/daily-reports/${rawId}/manual-review`, { approved, comment });
}

export function listDrafts(params) {
  return api.get('/work-task/drafts', { params });
}

export function triggerPreprocess(params) {
  return api.post('/work-task/drafts/preprocess', null, { params });
}

export function listTasks(params) {
  return api.get('/work-task/tasks', { params });
}

export function triggerPublish(params) {
  return api.post('/work-task/tasks/publish', null, { params });
}

export function listVerifications(params) {
  return api.get('/work-task/verifications', { params });
}

export function triggerVerification(params) {
  return api.post('/work-task/verifications/run', null, { params });
}

export function listAiJobs(params) {
  return api.get('/work-task/ai-jobs', { params });
}

export function listRegistryModules() {
  return api.get('/work-task/registry/modules');
}

export function listRegistryProjects() {
  return api.get('/work-task/registry/projects');
}

export function getTaskDetail(id) {
  return api.get(`/work-task/tasks/${id}`);
}

export function getTrace(params) {
  return api.get('/work-task/trace', { params });
}

export function getReportSummary(params) {
  return api.get('/work-task/reports/summary', { params });
}

export function runAudit() {
  return api.post('/work-task/audit/run');
}

export function listAuditIssues(params) {
  return api.get('/work-task/audit/issues', { params });
}

export function listSchedulerRuns(params) {
  return api.get('/work-task/scheduler-runs', { params });
}

export function getConfigHealth() {
  return api.get('/work-task/config/health');
}

export function getE2ePipeline(params) {
  return api.get('/work-task/e2e/pipeline', { params });
}

export function listWecomBindings(params) {
  return api.get('/work-task/users/wecom-bindings', { params });
}

export function bulkWecomBindings(bindings) {
  return api.post('/work-task/users/wecom-bindings/bulk', bindings);
}

export function bindWecomUser(userId, wecomUserId) {
  return api.put(`/work-task/users/${userId}/wecom-binding`, { wecomUserId });
}

export function pullDailyReports(params) {
  return api.post('/work-task/daily-reports/pull', null, { params });
}

export function stressTestVerification(params) {
  return api.post('/work-task/verifications/stress-test', null, { params });
}

export function getStressTestLast() {
  return api.get('/work-task/verifications/stress-test/last');
}

export function getMonitorSnapshot() {
  return api.get('/work-task/monitor/snapshot');
}

export function getAiQueueStats() {
  return api.get('/work-task/ai-jobs/queue-stats');
}

export function getMyWecomBinding() {
  return api.get('/work-task/me/wecom-binding');
}

export function getWecomOAuthUrl(params) {
  return api.get('/work-task/me/wecom/oauth/url', { params });
}

export function bindMyWecomManual(wecomUserId) {
  return api.put('/work-task/me/wecom-binding', { wecomUserId });
}

export function unbindMyWecom() {
  return api.delete('/work-task/me/wecom-binding');
}
